import { Http } from "../model/Http";
class saasIndex extends Http{
  // 获取首页数据
  getHomeMessage(data){
    const url = 'saas-backstage/home-page/home-data'
    return this.postAjaxBySaas(url,{
      ...data
    })
  }
  // 获取首页图表数据
  getEcharts(data){
    const url = 'saas-backstage/home-page/home-form-data'
    return this.postAjaxBySaas(url,{
      ...data
    })
  }
  // 公众号列表
  getOfficial(data){
    const url = 'saas-backstage/open-app/search'
    return this.postAjaxBySaas(url,{
      ...data
    })
  }
  // 查看推广链接
  checkLinks(data){
    const url = 'saas-backstage/open-app/promotional-links'
    return this.postAjaxBySaas(url,{
      ...data
    })
  }
  // 公众号价格
  officialPrice(data){
    const url = 'saas-backstage/open-app/add-app-fee'
    return this.postAjaxBySaas(url,{
      ...data
    })
  }
  // 票务号列表
  getTicketList(data){
    const url = 'saas-backstage/ticket-author/search'
    return this.postAjaxBySaas(url,{
      ...data
    })
  }
  // 查看票务号价格
  ticketPrice(data){
    const url = 'saas-backstage/ticket-author/add-ticket-fee'
    return this.postAjaxBySaas(url,{
      ...data
    })
  }
  // 票务号授权二维码
  ticketQrcode(data){
    const url = 'saas-backstage/ticket-author/ticket-qr-code'
    return this.postAjaxBySaas(url,{
      ...data
    })
  }
  // 支付二维码
  peyQrcode(data){
    const url = 'saas-pay/api-pay/sxy-recharge'
    return this.postAjaxBySaas(url,{
      ...data
    })
  }
  // 出票
  giveTicket(data){
    const url = 'saas-backstage/movie-order/issue-order'
    return this.postAjaxBySaasTicket(url,{
      ...data
    })
  }
  // 票务号详情
  ticketDetail(data){
    const url = 'saas-backstage/ticket-author/ticket-detail'
    return this.postAjaxBySaas(url,{
      ...data
    })
  }
  // 获取可授权数量
  getAuthorizationNum(data){
    const url = 'saas-backstage/open-app/check-auth'
    return this.postAjaxBySaas(url,{
      ...data
    })
  }
  // 同步模板消息
  synchronizationMessage(data){
    const url = '/open/open/app-template/sync'
    return this.postAjaxBySaas(url,{
      ...data
    },true)
  }
  // 解析二维码
  analysisQrcode(data){
    const url = 'saas-ticket/movie-order/decode-qrCode'
    return this.postAjaxBySaas(url,{
      ...data
    })
  }
  // 解锁
  unlockSeat(data){
    const url = 'saas-movie/zhongrui-api/zr-unlock-seat'
    return this.postAjaxBySaas(url,{
      ...data
    })
  }
  // 获取票务图片
  getTicketImg(data){
    const url = 'saas-backstage/home-page/right-url'
    return this.postAjaxBySaas(url,{
      ...data
    })
  }
  // 修改取票码
  modificationCode(data){
    const url = 'saas-backstage/movie-order/modify-issue-tickets'
    return this.postAjaxBySaasTicket(url,{
      ...data
    })
  }
  // 删除取票码
  deleteCodeImage(data){
    const url = 'saas-backstage/movie-order/delete-ticket-img'
    return this.postAjaxBySaas(url,{
      ...data
    })
  }
}
export {
  saasIndex
}



// WEBPACK FOOTER //
// ./src/javaApi/saasIndex.js